module.exports = __webpack_public_path__ + "img/4.e40a4679.png";